import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=80b96ece&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"
import style0 from "./Country.vue?vue&type=style&index=0&id=80b96ece&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b96ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b96ece')) {
      api.createRecord('80b96ece', component.options)
    } else {
      api.reload('80b96ece', component.options)
    }
    module.hot.accept("./Country.vue?vue&type=template&id=80b96ece&scoped=true", function () {
      api.rerender('80b96ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Country.vue"
export default component.exports